import script from "./PromptsView.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptsView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__